var map = {
	"./breakText/locale/es.js": "4dc7",
	"./breakText/locale/pt.js": "672c",
	"./cryptogramGenerator/locale/es.js": "2c27",
	"./cryptogramGenerator/locale/pt.js": "6773",
	"./fences/locale/es.js": "ec66",
	"./fences/locale/pt.js": "9ee2",
	"./generate/locale/es.js": "64fe",
	"./generate/locale/pt.js": "7d7c",
	"./huntingWordsGenerator/locale/es.js": "abd5",
	"./huntingWordsGenerator/locale/pt.js": "17a2",
	"./loop/locale/es.js": "a0e8",
	"./loop/locale/pt.js": "1ccc",
	"./numberSquare/locale/es.js": "d3ba",
	"./numberSquare/locale/pt.js": "a7e8",
	"./puzzle/locale/es.js": "6ade",
	"./puzzle/locale/pt.js": "13f3",
	"./puzzleTerm/locale/es.js": "66ec",
	"./puzzleTerm/locale/pt.js": "57ec",
	"./settings/locale/es.js": "edf8",
	"./settings/locale/pt.js": "fe7e",
	"./shapeLinks/locale/es.js": "a808",
	"./shapeLinks/locale/pt.js": "8cf1",
	"./specialCharacterRemover/locale/es.js": "8bc6",
	"./specialCharacterRemover/locale/pt.js": "1eec",
	"./user/locale/es.js": "ee08",
	"./user/locale/pt.js": "b487",
	"./walls/locale/es.js": "b632",
	"./walls/locale/pt.js": "4903",
	"./word/locale/es.js": "963b",
	"./word/locale/pt.js": "de95",
	"./wordGroups/locale/es.js": "cf26",
	"./wordGroups/locale/pt.js": "8c38",
	"./wordSeparator/locale/es.js": "7105",
	"./wordSeparator/locale/pt.js": "6fa2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de07";